import React, { useEffect, useState } from 'react';
import { Avatar, Dropdown, Menu } from 'antd';
import { NavLink } from 'react-router-dom';
import SkeletonImage from 'antd/lib/skeleton/Image';
import axios from "axios";
// import { Form } from 'react-formio';
import _ from 'underscore';
import setting from '../../../config/setting'
import logoIcon from '../../../assets/img/Icon metro-user.png';
import { history } from '../../../redux/store';

const logoType =  localStorage.getItem("logoType");

console.log("logoType :: ", logoType);

const accountItems = [
  // { text: 'Edit account', icon: 'icofont-ui-home', route: '/vertical/edit-account' },
  // { text: 'User profile', icon: 'icofont-ui-user', route: '/vertical/user-profile' },
  // { text: 'Calendar', icon: 'icofont-ui-calendar', route: '/vertical/events-calendar' },
  // { text: 'Settings', icon: 'icofont-ui-settings', route: '/vertical/settings' },
  { text: 'Log Out', icon: 'icofont-logout', route: '/public/sign-in/'+logoType }
];

const SettingsDropdown = () => {
  const [visible, setVisible] = useState([]);

  useEffect(() => {

    // setImageUser()

  }, []);


  // function setImageUser() {

  //   let newArr = [];

  //   axios.get(setting.serverUrl + '/api/userData', {
  //     // axios.get('http://localhost:3001/api/notifications', {
  //     params:
  //     {
  //       email: localStorage.getItem('myData'),
  //       user: localStorage.getItem('myData'),
  //       pass: localStorage.getItem('myPass')
  //     }
  //   }).then(response => {
  //     console.log("Respone from userData ", response.data)
  //     if (response && response.status == 200) {

  //       _.each(response.data, (userEach) => {

  //         if (userEach.email == localStorage.getItem('myData')) {

  //           newArr.push(userEach);
  //           setVisible(newArr)

  //         }

  //       })

  //     }
  //   })

  // }

  console.log("visible", visible)

  function logout() {

    const logoType =  localStorage.getItem("logoType");

    console.log("logoType :: ", logoType);
    localStorage.clear()
    if(logoType === 'msc' || logoType === 'metlife'){
      history.push({ pathname: '/public/sign-in/'+logoType, state: {} });
    }else{
      history.push({ pathname: '/public/sign-in/', state: {} });
    }
  }


  const accountMenu = (
    <Menu style={{ minWidth: '180px' }}>
      {accountItems.map((item, index) => (
        //   <Menu.Item key='logout' className='d-flex w-100'>
        //   <NavLink className='d-flex w-100' to='/public/sign-in' replace>
        //     <span
        //       className={`icon mr-2 icofont-logout`}
        //       style={{
        //         backgroundColor: '#379',
        //         borderRadius: 40,
        //         fontSize: 15,
        //         color: 'white',
        //         padding: 5
        //       }}
        //     />
        //     <span className='text'> Log Out</span>
        //   </NavLink>
        // </Menu.Item>
        <Menu.Item className='action-item' key={index}>
          {/* <NavLink className='d-flex w-100' to={item.route} replace> */}
          <div
          onClick={() => logout()} >
           <span
              className={`icon mr-2 icofont-logout`}
              style={{
                backgroundColor: '#379',
                borderRadius: 40,
                fontSize: 15,
                color: 'white',
                padding: 5
              }}
            />
           <span className='text'>{item.text}</span>
            </div>
           {/* </NavLink> */}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={accountMenu} trigger={['click']} placement='bottomRight'>
      <div className='item'>
      <img src={logoIcon} style={{ height: 15, width: 15, margin: 8 }} />
          {/* <Avatar
          //size={40}
          //className='mr-1'
          src={visible.length > 0 && visible[0].image_128 ? "data:image/png;base64," + visible[0].image_128 : ""} */}
          {/* //src="https://cdn2.iconfinder.com/data/icons/flat-style-svg-icons-part-1/512/user_logout_man-512.png"
        //src={`${window.location.origin}/content/user-40-2.jpg`} */}
          {/* /> */}
          <span className='icofont-simple-down' style={{ color: 'white' }} />

        {/* <Avatar
          //size={40}
          //className='mr-1'
          src={visible.length > 0 && visible[0].image_128 ? "data:image/png;base64," + visible[0].image_128 : ""}
        //src="https://cdn2.iconfinder.com/data/icons/flat-style-svg-icons-part-1/512/user_logout_man-512.png"
        //src={`${window.location.origin}/content/user-40-2.jpg`}
        /> */}
        <span className='icofont-simple-down' />
      </div>
    </Dropdown>
  );
};

export default SettingsDropdown;
